<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <kiosk-radio-filter
            label="Favorite"
            name="favorite"
            :options="favoriteOptions"
            v-model="filters.is_favorite"
        ></kiosk-radio-filter>
        <kiosk-radio-filter
            label="Suspended"
            name="suspended"
            :options="suspendedOptions"
            v-model="filters.is_suspended"
        ></kiosk-radio-filter>
    </div>
</template>

<script setup>
import KioskRadioFilter from '~/components/kiosk/KioskRadioFilter.vue';

const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const suspendedOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});
</script>
